export default function FormatDate({ timestamp }) {
  const date = new Date(Date.parse(timestamp))
  return date.toLocaleString('pt-BR')
}
